import React from 'react';
import { string, node, oneOfType } from 'prop-types';
import classNames from 'classnames';
import { Slim } from '@fiverr-private/modal';
import Subtitle from './Subtitle';
import Body from './Body';
import Footer from './Footer';

import './style.scss';

const Modal = ({ className, children, header = ' ', ...props }) => {
    className = classNames('collections_perseus', 'collections-perseus', 'action-modal', className);

    return (
        <Slim name={className} className="modal-content" header={header} {...props}>
            {children}
        </Slim>
    );
};

Modal.propTypes = {
    className: string,
    header: oneOfType([string, node]),
    children: node,
};

export { Subtitle, Body, Footer };

export default Modal;
